/**
 *  Module for sending analytics to omniture and google analytics
 */

const Tools = function(app) {

  /**
   *  Private Properties/Methods
   */

  const _ = require('lodash'),
    localAnalytics = require('./_localAnalytics')(),
    md5 = require('md5');

  const showAnalytics = app.mergedParams.showAnalytics;

  if ( showAnalytics ) {
    localAnalytics.showLogging();
  }

  // Only show missing analytics object errors once
  const configure = app.configure,
    eventCategory = 'Configure';

  // Gets the current recipeId for analytics
  function getRecipeId(data) {
    if (data && data.recipeId) {
      // RecipeId passed in as event parameter
      return data.recipeId;
    } else {
      // Get currently loaded recipeId
      const fcParams = app.configure.run('getFcParams');
      return fcParams.recipeId;
    }
  }

  function getPrice() {
    return app.price.getPrice(true);
  }
  function sortObject(data) {
    const ordered = {};
    Object.keys(data).sort().forEach(function(key) {
      ordered[key] = data[key];
    });
    return ordered;
  }
  function getProductData(recipe, attributes) {
    const data = {};

    _.forEach(attributes, function(attr) {
      _.forEach(recipe, function(item) {
        if ( item.ca.alias === attr.alias && attr.selectorType !== 'none' ) {
          const caId = item.ca.id;

          if ( item.av && item.av.hasOwnProperty('text') && item.av.text !== '' ) {
            data[caId] = item.av.text;
          } else if ( item.av && item.av.id ) {
            data[caId] = item.av.id;
          }
        }
      });
    });

    return sortObject(data);
  }

  function getSelections() {
    const attributes = app.getRenderableAttributes(true);
    return getProductData(configure.run('getRecipe', 'json'), attributes);
  }

  function getSelectionsString() {
    const selections = getSelections();
    let str = '';
    _.forEach(selections, function(value, key) {
      if (value && key) {
        str += key +':'+ value +',';
      }
    });
    return str;
  }

  function getProductName() {
    return app.product.name;
  }

  function getProductVendorId() {
    return app.product.vendorId;
  }

  function getProperties(properties, recipeId, addSelections) {
    const data = {};

    data.name = getProductVendorId();
    data.price = getPrice();
    // data.productCategory = 'watch';

    if (recipeId) {
      data.recipeId = recipeId;
    }

    if (recipeId && addSelections) {
      data.selections = getSelectionsString();
    }

    return _.merge({}, data, properties);
  }

  function parseProperties(props) {
    let string = '';

    props = _.omit(props, 'action');

    _.forEach(props, function(item, key) {
      string += key;
      string += ':';
      string += (
        (_.isObject(item)) ?
          JSON.stringify(item) :
          (_.isString(item) ? item.replace(/\-/g, '_') : item)
      );
      string += '-';
    });

    return string;
  }
  function getAllowedChanges(changes) {
    const allowed = [],
      attrs = app.getRenderableAttributes(true);

    // Loop through all the changes
    _.forEach(changes, function(item) {
      // Loop through the alias map so we only allow those items
      _.forEach(attrs, function(attr) {
        // If the change alias matches one of the allowed aliases
        if ( item.ca.alias === attr.alias ) {
          allowed.push(item);
        }
      });
    });
    return allowed;
  }
  // Take a recipe:change array and return the allowed values as a string
  function getChanges(changes) {
    const allowed = getAllowedChanges(changes);
    let str_output = '';

    _.forEach(allowed, function(change) {
      let value;

      if ( change.ca.alias.indexOf('selector') >= 0 ) {
        value = change.av.description +':'+ change.av.name;
      } else {
        value = ( change.av ) ? change.av.id : '';
      }

      str_output += change.ca.id +': '+ value +',';
    });

    // Since we add a comma to the end of each change
    //  remove the very last character so we don't have
    //  a trailing comma
    str_output = str_output.slice(0, -1);

    if ( typeof str_output !== 'undefined' && str_output !== '' ) {
      return str_output;
    }
  }
  function getPageName() {
    return app.product.locale + ':pdp:' + app.product.vendorId;
  }
  function getCurrency() {
    return configure.run('getCurrency');
  }

  function recipeCreated(recipe) {
    const data = {
      'id': recipe.styleId,
      'name': recipe.product.vendor_id,
      'brand': getSelectionsString(),
      'variant': 'Recipe:'+ recipe.id,
      'category': _.head(configure.run('getProduct').facets.Type),
      'price': getPrice(),
      'quantity': parseInt(recipe.product_quantities.product, 10)
    };

    ga('Fluid.set', '&cu', 'USD');               // Fluid
    // Add stuff to GA ecom module
    ga('Fluid.ec:addProduct', data);             // Fluid
    // Send it!
    ga('Fluid.ec:setAction', 'add');             // Fluid
    /* ----------  customer analytics  ---------- */
    digitalData = {
      event: {
        eventInfo: {
          eventName: 'recipeSaved' + app.analytics.incrementalNumber//static value
        }
      },
      page: {
        pageName: getPageName()
      },
      product: {
        item: {
          productCurrency: getCurrency(), //based on location
          productName: getProductName(), //the name of the product added to the cart
          productPrice: data.price, //the price of the product added to the cart
          productSKU: recipe.styleId, //the product SKU
          productRecipeID: recipe.id //the product Recipe ID
        }
      }
    };

    if ( showAnalytics ) {
      console.log('Fluid.set', '&cu', 'USD');
      console.log('Fluid.ec:addProduct', data);
      console.log('Fluid.ec:setAction', 'add');
      const stringifiedDigitalData = JSON.stringify(digitalData, null, 2);
      console.log('%c digitalData: ' + stringifiedDigitalData, 'background: #008080; color: #bada55');
    }
  }

  function setSession() {
    const sessionKey = md5(process.env.customer + ' - ' + process.env.customer_id),
      session = sessionStorage.getItem(sessionKey),
      sessionId = Math.floor(Math.random() * 99999999999);
    let newSession = true;

    if ( !session ) {
      sessionStorage.setItem(sessionKey, sessionId);

      if ( showAnalytics ) {
        console.log('Session ID Created:', sessionId);
      }

      ga('Fluid.send', 'event', eventCategory, 'Session Created', 'id='+sessionId);
    } else {
      newSession = false;
    }

    return newSession;
  }
  function getStyleId() {
    if (app.appUtils.isDTGProduct()) {
      return 'dtg';
    } else {
      const styleNumber = app.helpers.getFacetsByAlias('oms_sku')['style_#'];
      return styleNumber ? styleNumber.name : '';
    }
  }

  /**
   *  Expose Public Properties/Methods
   */
  return {
    getChanges,
    getCurrency,
    getProperties,
    getPageName,
    getProductName,
    getRecipeId,
    getSelections,
    getSelectionsString,
    getStyleId,
    parseProperties,
    recipeCreated,
    setSession,
    getPrice
  };
};

module.exports = Tools;
